import {gql} from "@apollo/client";

export const CHANGE_LANGUAGE_MUTATION = gql`mutation ChangeLanguageMutation($value: String!){
                        changeLanguage (
                            value: $value
                        )
                        {
                            language
                        }
                    }`;
